import React, { useState, useEffect } from "react";
import OrderHeader from "./OrderHeader";

export default function Order(props) {
  const { final, setFinal, data, currentConfig } = props;
  const [visible, setVisible] = useState(false);
  const [tot, setTot] = useState("_");

  const onClickHandler = () => {
    console.log(visible);
    setVisible(!visible);
  };

  const fetchTot = async () => {
    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data[0]?.step?.order?.articoli),
      };
      const res = await fetch(
        "https://www.kit.solutions/api/zucchetti/prezzi/",
        requestOptions
      );
      const ret = await res.json();
      setTot(ret[0].TOT);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (data[0]?.step?.order?.articoli) {
      fetchTot();
    }
  }, [data]);

  // useEffect(async () => {
  //   try {
  //     const requestOptions = {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(final),
  //     };
  //     const res = await fetch(
  //       "http://dev.kit.solutions/api/zucchetti/prezzi/",
  //       requestOptions
  //     );
  //     console.log(await res.json());
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }, [JSON.stringify(final)]);

  const visiblestyleContainer = {};
  /*visible
    ? {
        //position: "absolute",
        top: 0,
        bottom: 0,
        width: "100%",
        backgroundColor: "#fff",
      }
    : {
        position: "relative",
      };
*/
  const visiblestylebody = {};
  /*visible
    ? {
        display: "block",
      }
    : {
        display: "none",
      };
      */

  return (
    <div style={visiblestyleContainer}>
      <div
        style={{
          backgroundColor: "white",
          margin: 0,
        }}
      ></div>
      <div
        style={{
          backgroundColor: "white",
          minHeight: "50%",
          height: "100%",
          overflowY: "auto",
          padding: "10px",
          ...visiblestylebody,
        }}
      >
        {/*
        <div className="tt_total">TOT {tot} &euro;</div>
       */}
        <table
          style={{
            width: "100%",
            textAlign: "left",
            fontSize: "12px",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          <tbody>
            <tr>
              <th>Q.</th>
              <th style={{ minWidth: "120px" }}>Codice</th>
              <th style={{ minWidth: "50px" }}>Posizione</th>
              <th>Descrizione</th>
            </tr>
            {final.face && (
              <tr>
                <td>1</td>
                <td>{currentConfig?.face?.code}</td>
                <td>T1</td>
                <td>{currentConfig?.face?.description}</td>
              </tr>
            )}
            {final.footer && (
              <tr>
                <td>1</td>
                <td>{currentConfig?.footer?.code}</td>
                <td>T2</td>
                <td>{currentConfig?.footer?.description}</td>
              </tr>
            )}

            {final?.central?.data.map((d, k) => {
              return (
                <tr>
                  <td>1</td>
                  <td>{d?.code}</td>
                  <td>{`C${Math.floor(k / 2 + 1)}.${
                    (k + 1) % 2 == 0 ? "DX" : "SX"
                  }`}</td>
                  <td>{d?.description}</td>
                </tr>
              );
            })}
            {final?.portal && (
              <tr>
                <td>{final?.portal?.qty}</td>
                <td>{final?.portal?.code}</td>
                <td> - </td>
                <td>{final?.portal?.description}</td>
              </tr>
            )}
            {final?.wallcode?.map((w) => {
              if (w.wallcode) {
                return (
                  <tr>
                    <td>{w?.qty}</td>
                    <td>{w?.wallcode}</td>
                    <td> - </td>
                    <td>{w?.description}</td>
                  </tr>
                );
              }
            })}
            {final?.tinsmith?.map((t) => {
              return (
                <tr>
                  <td>{t.qty}</td>
                  <td>{t.code}</td>
                  <td> - </td>
                  <td>{t.description}</td>
                </tr>
              );
            })}
            {final?.window && final?.totWindows > 0 && (
              <tr>
                <td>{final?.totWindows}</td>
                <td>{final?.window?.code}</td>
                <td> - </td>
                <td>{final?.window?.description}</td>
              </tr>
            )}
            {final?.bigDoor && final?.totBigDoor > 0 && (
              <tr>
                <td>{final?.totBigDoor}</td>
                <td>{final?.bigDoor?.code}</td>
                <td> - </td>
                <td>{final?.bigDoor?.description}</td>
              </tr>
            )}
            {final?.smallDoor && final?.totSmallDoor && (
              <tr>
                <td>{final?.totSmallDoor}</td>
                <td>{final?.smallDoor?.code}</td>
                <td> - </td>
                <td>{final?.smallDoor?.description}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
